import { COMPONENT_NAME as TABS_COMPONENT_NAME } from '../tabs/tabs.component'

import { IMRTabController } from "./tab.controller"

//#region Asset Imports

import './tab.scss'
import * as TEMPLATE from './tab.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrTab'

export class IMRTabComponent implements ng.IComponentOptions {

    controller = ['$element', IMRTabController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    require = {
        parentController: `^^${TABS_COMPONENT_NAME}`
    } as { [index: string]: string }

    template = TEMPLATE

    transclude = true
}
